module.exports = "/images/map.png?f5091c087ad9637e730860061ce12686";